const StaffContent = ({imgUrl, name, rank}) =>{
  return (
    <>
      <div className = "bg-gray-500 flex flex-row justify-center items-center w-56">
        <div className = "flex flex-col justify-center items-center gap-5">
          <div>
            <img src = {imgUrl} alt="pexels-linkedin-2182970" className = "w-40 rounded-md"/>
          </div>
          <div className = "flex flex-col justify-center items-center pb-4"> 
            <p className = "text-xl text-white font-bold"> {name}</p>
            <p className = "text-white">{rank}</p>
          </div>
        </div>
      </div>
    </>
  ); 
}
export default StaffContent; 
